import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { useLocation } from "react-router-dom";

import AdminErrorBoundary from "./AdminErrorBoundary";
import AdminSidebar from "./AdminSidebar";
import "./adminDashboard.css";

function sidebarKeyFromPath(pathname) {
  const p = pathname.replace(/\/$/, "") || "/admin";
  if (p === "/admin") return "dashboard";
  if (/^\/admin\/posts\/.+\/edit$/.test(p)) return "posts";
  if (p === "/admin/posts") return "posts";
  if (p === "/admin/articles/new") return "createPost";
  if (/^\/admin\/articles\/.+\/edit$/.test(p)) return "createPost";
  if (p === "/admin/messages") return "messages";
  if (p === "/admin/volunteers") return "volunteers";
  if (p === "/admin/media") return "media";
  if (p === "/admin/analytics") return "analytics";
  if (p === "/admin/settings") return "settings";
  return "dashboard";
}

export default function AdminShell({ title, subtitle, actions, children }) {
  const [sideOpen, setSideOpen] = useState(false);
  const location = useLocation();
  const activeKey = sidebarKeyFromPath(location.pathname);

  return (
    <AdminErrorBoundary>
      <div className="adminPage">
        <div className="adminShell">
          <aside className="adminSide">
            <AdminSidebar activeKey={activeKey} onNavigate={() => {}} />
          </aside>

          <div className={`adminSideOverlay ${sideOpen ? "open" : ""}`} onClick={() => setSideOpen(false)} role="presentation" />

          <aside className={`adminSideDrawer ${sideOpen ? "open" : ""}`} aria-label="Admin sidebar drawer">
            <AdminSidebar
              activeKey={activeKey}
              onNavigate={() => {
                setSideOpen(false);
              }}
            />
          </aside>

          <main className="adminMain">
            <div className="adminContainer">
              <div className="adminHeader">
                <div className="adminHeaderLeft">
                  <button type="button" className="adminSideToggle" onClick={() => setSideOpen(true)} aria-label="Open sidebar">
                    <FaBars />
                  </button>
                  <div>
                    <h1 className="adminHeaderTitle">{title}</h1>
                    {subtitle ? <p className="adminHeaderSubtitle">{subtitle}</p> : null}
                  </div>
                </div>
                <div>{actions}</div>
              </div>

              {children}
            </div>
          </main>
        </div>
      </div>
    </AdminErrorBoundary>
  );
}

